import React from 'react';

import { Desktop, Mobile } from '../../Common/const';

class NotificationsViewHeader extends React.Component {
  render() {
    return (
      <div>
        <Desktop>
          <div className="resources-header-container pt-5 pl-4 pb-5">
            Flight Log
          </div>
          <div className="gradient-divider" />
        </Desktop>
        <Mobile>
          <div className="resources-header-container pt-2 pl-2 pb-1">
            Flight Log
          </div>
        </Mobile>
      </div>
    );
  }
}

export default NotificationsViewHeader;
